var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-table',{attrs:{"items":_vm.stats,"fields":_vm.fields,"show-empty":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }